import {
  EnvelopeSubmission,
  MarketingContributions,
  MarketingItemType,
  MarketingPackageStage,
  UploadedDocument,
} from '@urbanx/agx-ui-components';

export interface MarketingPackage {
  id: string;
  name: string;
  displayName: string;
  includeRealEstateListing: boolean;
  includeDomainListing: boolean;
  displayItemisedPricingOnPdf: boolean;
  specialConditions: string;
  items: string[];
  addOns: string[];
  assignedAgentIds: string[];
}

export interface MarketingPackageModel {
  id: string;
  packageTemplateId: string;
  packageTemplateName: string;
  packageDisplayName?: string;
  agencyId: string;
  campaignId: string;
  includedInAgencyAgreement: boolean;
  lastUpdated: string;
  stage: { value: MarketingPackageStage };
  confirmedTotal?: number;
  inclusions?: MarketingPackageItem[];
  addons?: MarketingPackageItem[];
  envelopeSubmission?: EnvelopeSubmission;
  document?: UploadedDocument;
  displayStatus?: CampaignFlowDisplayStatus;
  displayStatusExtraInfo?: string;
  marketingContributions?: MarketingContributions;
}

export interface MarketingPackageItem {
  itemTemplateId: string;
  itemTemplateName: string;
  pricePerUnit: number | null;
  quantity: number | null;
}

export interface MarketingItem {
  id: string;
  productName: string;
  pricePerUnit: number | null;
  itemType: MarketingItemType;
  supplier: string | null;
  stockType: string | null;
}

export interface MarketingPackageUpdatedEvent {
  marketingPackageId: string;
  campaignId: string;
}

export enum CampaignFlowDisplayStatus {
  AwaitingFunds = 'AwaitingFunds',
  PayLaterApplicationSigned = 'PayLaterApplicationSigned',
  Paid = 'Paid',
  Cancelled = 'Cancelled',
  PendingSettlement = 'PendingSettlement',
  Complete = 'Complete',
  Withdrawn = 'Withdrawn',
  PayLaterDeclined = 'PayLaterDeclined',
  Draft = 'Draft',
}
